import React, { Component } from "react";
import TableWithLoadingWrapper from "../../generic/dataGrid";

class AuthorizedUsersTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  };

  render() {
    const columns = [
      {
        field: 'fullName',
        headerName: 'Authorized User',
        flex: 1.5,
        sortable: true,
        valueGetter: (params) => {
          return params.first + ' ' + params.last;
        },
        sortComparator: (a, b) => {
          return a.localeCompare(b);
        },
        renderCell: (params) => (
          <p>{params.value}</p>
        ),
      },
      {
        field: 'email',
        headerName: 'Email',
        flex: 2,
        sortable: true,
        sortComparator: (a, b) => a.localeCompare(b),
        renderCell: (params) => (
          <p>{params.value}</p>
        ),
      },
      {
        field: 'phone',
        headerName: 'Phone Number',
        flex: 1,
        sortable: true,
        valueGetter: (params) => {
          return params.countryCode + ' ' + params.number;
        },
        sortComparator: (a, b) => {
          return a.localeCompare(b);
        },
        renderCell: (params) => (
          <p>{`+${params.value}`}</p>
        ),
      },
    ];
    
    return (
      <TableWithLoadingWrapper
        columns={columns}
        dataSource={this.props.authorizedUsersData}
        tableLayout="fixed"
        getRowId={row => row.email}
      />
    );
  }
}

export default AuthorizedUsersTable;
